import { gql } from "@apollo/client";

export const LOGIN = gql`
  mutation AdminLogIn($username: String!, $password: String!) {
    AdminLogIn(password: $password, username: $username) {
      accessToken
      message
      error
    }
  }
`;

export const AUTHENTICATE = gql`
  mutation authorize($phone: String!, $password: String!) {
    LogIn(phone: $phone, password: $password) {
      accessToken
      error
      message
    }
  }
`;